import $ from 'jquery';

// 顶点在矩形中所处位置
const POINT_TYPE = {
    LEFT_UP: 0,
    LEFT_DOWN: 3,
    RIGHT_UP: 1,
    RIGHT_DOWN: 2,
};

// 象限
const QUADRANT = {
    ONE: 'ONE',
    TWO: 'TWO',
    THREE: 'THREE',
    FOUR: 'FOUR',
};

/**
 * @desc 获取dom容器中子元素矩形的各个顶点
 * @param {Element} element 需要生成背景的dom容器
 * @param {number} angle dom元素设置的的旋转角度
 * @returns {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints
 */
const _getElementsChildrenPeakPoints = (element, angle) => {
    if (!element) return;
    let preRect = element.getBoundingClientRect();
    if (preRect.width === 0 && preRect.height === 0) return;

    let textLine = $(element).find('div');
    if (textLine.length === 0) return;

    // 调整容器的旋转角度,保证旋转角度始终等于0
    $(element).css({
        transform: `rotate(-${angle}deg)`,
    });

    // 重新获取旋转角度为0的坐标
    preRect = element.getBoundingClientRect();
    textLine = $(element).find('div');
    let rectPeakPoints = [];

    // 原点坐标为背景容器的左上顶点
    let originPoint = { x: preRect.x, y: preRect.y };

    for (let i = 0; i < textLine.length; i++) {
        let lineDom = textLine[i];

        let leftUp = { x: 0, y: 0 },
            rightUp = { x: 0, y: 0 },
            rightDown = { x: 0, y: 0 },
            leftDown = { x: 0, y: 0 };

        const rect = lineDom.getBoundingClientRect();

        leftUp = {
            x: rect.x - originPoint.x,
            y: rect.y - originPoint.y,
        };
        rightUp = {
            x: rect.right - originPoint.x,
            y: rect.y - originPoint.y,
        };
        rightDown = {
            x: rect.right - originPoint.x,
            y: rect.bottom - originPoint.y,
        };
        leftDown = {
            x: rect.x - originPoint.x,
            y: rect.bottom - originPoint.y,
        };
        // 以下操作用于消除dom元素之间的间隙
        // 让当前行矩形的上边俩点的y轴值完全等于上一个矩形的下边俩点的y值
        if (i > 0) {
            let preIndex = rectPeakPoints.length - 1;
            leftUp.y = rectPeakPoints[preIndex][POINT_TYPE.RIGHT_DOWN].y;
            rightUp.y = rectPeakPoints[preIndex][POINT_TYPE.RIGHT_DOWN].y;
        }

        rectPeakPoints.push([leftUp, rightUp, rightDown, leftDown]);
    }
    $(element).css({
        transform: `none`,
    });
    return rectPeakPoints;
};

/**
 * @desc 通过每行的矩形顶点坐标获取背景svg每个拐角的顶点坐标, 从右侧最上边顶点顺时针统计返回列表
 * @param {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoint
 */
const _getBackgroundSvgPeakPoint = rectPeakPoints => {
    // 背景的拐角顶点从右上角顶点顺时针统计
    let svgPeakPoints = [];
    let maxRadiusList = [];

    // 添加svg拐角顶点 以及 当前顶点的最大弧度值
    // 最大弧度取 宽度 / 高度 的一半 看高和宽那个的值最小
    const __addPointAndMaxRadius = (point, rect) => {
        const rectWidth = rect[POINT_TYPE.RIGHT_UP].x - rect[POINT_TYPE.LEFT_UP].x;
        const rectHeight = rect[POINT_TYPE.RIGHT_DOWN].y - rect[POINT_TYPE.RIGHT_UP].y;

        let maxRadius = rectWidth > rectHeight ? rectHeight : rectWidth;
        maxRadiusList.push(maxRadius / 2);

        svgPeakPoints.push({ ...point });
    };

    // 从右边顶点顺时针记录
    // 右边顶点添加
    for (let i = 0; i < rectPeakPoints.length; i++) {
        let rect = rectPeakPoints[i];
        // 右边顶点添加
        if (i === 0) {
            __addPointAndMaxRadius(rect[POINT_TYPE.RIGHT_UP], rect);
            __addPointAndMaxRadius(rect[POINT_TYPE.RIGHT_DOWN], rect);
        } else {
            let prePoint = svgPeakPoints[svgPeakPoints.length - 1];

            // 如果与上一个点的x值相等，则上一个点不是一个顶点， 所以更改上一个点成当前矩形的右下顶点
            if (prePoint.x === rect[POINT_TYPE.RIGHT_UP].x) {
                // 去除上一个点的记录
                maxRadiusList.length -= 1;
                svgPeakPoints.length -= 1;

                __addPointAndMaxRadius(rect[POINT_TYPE.RIGHT_DOWN], rect);
            } else {
                __addPointAndMaxRadius(rect[POINT_TYPE.RIGHT_UP], rect);
                __addPointAndMaxRadius(rect[POINT_TYPE.RIGHT_DOWN], rect);
            }
        }
    }

    // 左边顶点添加
    for (let i = rectPeakPoints.length - 1; i >= 0; i--) {
        let rect = rectPeakPoints[i];
        // 左边顶点添加
        let prePoint = svgPeakPoints[svgPeakPoints.length - 1];

        // 如果与上一个点的x值相等，则上一个点不是一个顶点， 所以更改上一个点成当前矩形的右下顶点
        if (prePoint.x === rect[POINT_TYPE.LEFT_DOWN].x) {
            // 去除上一个点的记录
            maxRadiusList.length -= 1;
            svgPeakPoints.length -= 1;

            __addPointAndMaxRadius(rect[POINT_TYPE.LEFT_UP], rect);
        } else {
            __addPointAndMaxRadius(rect[POINT_TYPE.LEFT_DOWN], rect);
            __addPointAndMaxRadius(rect[POINT_TYPE.LEFT_UP], rect);
        }
    }

    return { svgPeakPoints, maxRadiusList };
};

/**
 * @desc 通过svg背景顶点点信息列表计算相对应的顶点弧度的开始点和结束点，以及三次贝塞尔曲线的每个开始点，结束点的控制点
 * @param {[]} svgPeakPoints
 * @param {[number]} pointRadiusList
 */
const _getArcStartAndEndPoints = (svgPeakPoints, pointRadiusList) => {
    let peakPointInfoList = [];
    const __getPeakPointInfoList = (svgPeakPoints, pointRadiusList, index) => {
        if (svgPeakPoints.length <= index) return;

        const peakPointNum = svgPeakPoints.length;
        const prePoint = svgPeakPoints[(index - 1 + peakPointNum) % peakPointNum];
        const point = svgPeakPoints[index];
        const nextPoint = svgPeakPoints[(index + 1) % peakPointNum];

        let pointType = _judgePeakPointPosition(prePoint, point, nextPoint);
        let arcQuadrant = _judgeArc(prePoint, point, nextPoint);

        let radiusPX = pointRadiusList[index];

        let peakPointInfo = _getArcStartAndEndPoint(point, radiusPX, {
            arcQuadrant,
            pointType,
            prePoint,
            nextPoint,
        });
        peakPointInfoList.push(peakPointInfo);
        __getPeakPointInfoList(svgPeakPoints, pointRadiusList, index + 1);
    };

    __getPeakPointInfoList(svgPeakPoints, pointRadiusList, 0);

    return peakPointInfoList;
};

/**
 * @desc 判断顶点在矩形中的位置
 * @param {x,y} prePoint 上一个顶点
 * @param {x,y} point
 * @param {x,y} nextPoint 下一个顶点
 */
const _judgePeakPointPosition = (prePoint, point, nextPoint) => {
    let pointType = null;

    // 在矩形的左上位置和右下位置时 当前点和下一点y相等
    if (point.y === nextPoint.y) {
        if (point.y > prePoint.y) {
            // 位于矩形右下的顶点
            pointType = POINT_TYPE.RIGHT_DOWN;
        } else {
            // 位于矩形左上的顶点
            pointType = POINT_TYPE.LEFT_UP;
        }
    }

    // 在矩形的右上顶点时，当前点的y坐标小于下一点的y坐标
    if (point.y < nextPoint.y) {
        pointType = POINT_TYPE.RIGHT_UP;
    }

    // 在矩形的左下顶点时，当前点的y坐标大于下一点的y坐标
    if (point.y > nextPoint.y) {
        pointType = POINT_TYPE.LEFT_DOWN;
    }

    return pointType;
};

/**
 * @desc 判断顶点的弧线所处象限
 * @param {x,y} prePoint 上一个顶点
 * @param {x,y} point
 * @param {x,y} nextPoint 下一个顶点
 */
const _judgeArc = (prePoint, point, nextPoint) => {
    let arcQuadrant = null;

    // 判断弧线在圆上的的位置
    // 计算prePoint 和 nextPoint 的中点
    // 该中点的位置相对于point 来说就是圆心的方向，可以确认弧线的象限
    const centrePoint = {
        x: (prePoint.x + nextPoint.x) / 2,
        y: (prePoint.y + nextPoint.y) / 2,
    };

    if (centrePoint.x < point.x) {
        if (centrePoint.y > point.y) {
            arcQuadrant = QUADRANT.ONE;
        } else {
            arcQuadrant = QUADRANT.FOUR;
        }
    } else {
        if (centrePoint.y > point.y) {
            arcQuadrant = QUADRANT.TWO;
        } else {
            arcQuadrant = QUADRANT.THREE;
        }
    }

    return arcQuadrant;
};

/**
 * @desc 通过一条直角边的前后俩个点左边，获取x,y轴可设置的最大弧度
 * @param {*} prePoint
 * @param {*} nextPoint
 */
const _getMaxRadius = (prePoint, nextPoint) => {
    let maxRadiusY = Math.abs(nextPoint.y - prePoint.y) / 2;
    let maxRadiusX = Math.abs(nextPoint.x - prePoint.x) / 2;

    return {
        maxRadiusY,
        maxRadiusX,
    };
};
/**
 * @desc 获取顶点弧线的开始点和结束点的坐标,以及控制点坐标
 * @param {{x,y}} point
 * @param {number} radius
 * @param {{x,y}} options.prePoint
 * @param {{x,y}} options.nextPoint
 * @param {QUADRANT} options.arcQuadrant
 * @param {POINT_TYPE} options.pointType
 */
const _getArcStartAndEndPoint = (point, radius, options) => {
    const { prePoint, nextPoint, arcQuadrant, pointType } = options;

    let start = null,
        end = null;

    let startControl = null,
        endControl = null;

    // 当前顶点能设置的最大弧度
    let { maxRadiusX, maxRadiusY } = _getMaxRadius(prePoint, nextPoint);

    const offset = _getOffsetOfArcQuadrant(arcQuadrant, maxRadiusX, radius, maxRadiusY);

    const { startOffset, endOffset } = _getStartAndEndOffset(pointType, offset);

    start = {
        x: point.x + startOffset.x,
        y: point.y + startOffset.y,
    };

    end = {
        x: point.x + endOffset.x,
        y: point.y + endOffset.y,
    };

    let angle = _getArcAngle(start.x, end.x, radius);

    // 在 _getArcAngle 计算中存在计算精度问题,所以手动排除能够完整设置圆角的情况
    if (radius === offset.x) angle === Math.PI / 2;

    // 如果弧度不满足 1/4 圆 则表示当前点无法完整设置顶点圆角,
    // 此时需要将y轴做上移/下移的调整以满足样式要求
    if (radius !== 0 && angle !== Math.PI / 2) {
        let offsetY = radius - Math.sin(angle) * radius;
        _adjustStartOrEndOfPointType(pointType, start, end, offsetY);
    }

    let controlPoint = _getControlPoint(start, end, {
        radius,
        arcQuadrant,
        pointType,
    });

    if (controlPoint) {
        startControl = controlPoint.startControl;
        endControl = controlPoint.endControl;
    }

    return {
        startPoint: start,
        endPoint: end,
        startControl,
        endControl,
    };
};

/**
 * @desc 通过顶点的类型<顶点在矩形中的位置> 调整顶点弧线的起始点/终点
 * @param {POINT_TYPE} pointType 顶点在矩形中的位置
 * @param {{x,y}} startPoint
 * @param {{x,y}} endPoint
 * @param {{x,y}} offsetY
 */
const _adjustStartOrEndOfPointType = (pointType, startPoint, endPoint, offsetY) => {
    switch (pointType) {
        case POINT_TYPE.RIGHT_UP: {
            endPoint.y -= offsetY;
            break;
        }
        case POINT_TYPE.RIGHT_DOWN: {
            startPoint.y += offsetY;
            break;
        }
        case POINT_TYPE.LEFT_UP: {
            startPoint.y -= offsetY;
            break;
        }
        case POINT_TYPE.LEFT_DOWN: {
            endPoint.y += offsetY;
            break;
        }
    }
};

/**
 * @desc 通过同一个圆上的俩个点之间的x轴距离和圆的半径获取这俩个点之间弧线的弧度 只能计算角度小于90的情况
 * @param {number} startX 起点的x坐标
 * @param {number} endX   终点的x坐标
 * @param {number} radius  半径
 */
const _getArcAngle = (startX, endX, radius) => {
    const interval = Math.abs(startX - endX);
    const a = radius - interval;
    let angle = Math.acos(a / radius);
    return angle;
};

/**
 * @desc 获取三阶贝塞尔曲线控制点离起点/终点的距离
 * @param {number} angle
 * @param {number} radius
 */
const _getControlPointInterval = (angle, radius) => {
    return (4 / 3) * Math.tan(angle / 4) * radius;
};

/**
 * @desc 获取起点和终点的控制点
 * @param {{x,y}} start
 * @param {{x,y}} end
 * @param {QUADRANT} options.arcQuadrant
 * @param {POINT_TYPE} options.pointType
 */
const _getControlPoint = (start, end, options) => {
    const { radius, arcQuadrant, pointType } = options;
    if (radius === 0) return;

    const angle = _getArcAngle(start.x, end.x, radius);

    let startControl = { x: 0, y: 0 }, // 起点控制点位置
        endControl = { x: 0, y: 0 }; // 终点控制点位置

    let { startOffset, endOffset } = _getControlPointOffset(radius, angle, arcQuadrant, pointType);

    startControl = {
        x: start.x + startOffset.x,
        y: start.y + startOffset.y,
    };

    endControl = {
        x: end.x + endOffset.x,
        y: end.y + endOffset.y,
    };

    return { startControl, endControl };
};
/**
 * @desc 获取控制点相对于被控制点的偏移
 * @param {number} radius
 * @param {number} angle
 * @param {QUADRANT} arcQuadrant
 * @param {POINT_TYPE} pointType
 * @returns
 */
const _getControlPointOffset = (radius, angle, arcQuadrant, pointType) => {
    // 控制点和被控制点之间的距离
    const interval = _getControlPointInterval(angle, radius);

    // 控制点距离起点的偏移值 默认弧度满足1/4的圆
    // offset.y 初始值设置为0的原因， 在弧度满足的情况下y轴控制点的偏移值分为俩种情况
    // 1. 垂直上下偏移  偏移值等于interval // 在不满足1/4弧度时也等于interval, 所以单独处理 不算在offset偏移中
    // 2. 水平偏移 偏移值等于0
    let offset = {
        x: interval,
        y: 0,
    };
    let startOffset = { x: 0, y: 0 }, // 起点的控制点偏移值
        endOffset = { x: 0, y: 0 }; // 终点的控制点偏移

    // 不满足1/4的圆时重新计算偏移值
    if (angle !== Math.PI / 2) {
        offset.x = interval * Math.sin(angle);
        offset.y = interval * Math.cos(angle);
    }

    switch (arcQuadrant) {
        case QUADRANT.ONE: {
            if (pointType === POINT_TYPE.RIGHT_UP) {
                // 矩形右上顶点
                startOffset.x = offset.x;
                startOffset.y = offset.y;

                endOffset.x = 0;
                endOffset.y = -interval;
            } else {
                // 矩形左上顶点
                startOffset.x = 0;
                startOffset.y = -interval;

                endOffset.x = offset.x;
                endOffset.y = offset.y;
            }
            break;
        }
        case QUADRANT.TWO: {
            if (pointType === POINT_TYPE.RIGHT_UP) {
                // 矩形右上顶点
                startOffset.x = -offset.x;
                startOffset.y = offset.y;

                endOffset.x = 0;
                endOffset.y = -interval;
            } else {
                // 矩形左上顶点
                startOffset.x = 0;
                startOffset.y = -interval;

                endOffset.x = -offset.x;
                endOffset.y = offset.y;
            }
            break;
        }
        case QUADRANT.THREE: {
            if (pointType === POINT_TYPE.RIGHT_DOWN) {
                // 矩形右下顶点
                startOffset.x = 0;
                startOffset.y = interval;

                endOffset.x = -offset.x;
                endOffset.y = -offset.y;
            } else {
                // 矩形左下顶点
                startOffset.x = -offset.x;
                startOffset.y = -offset.y;

                endOffset.x = 0;
                endOffset.y = interval;
            }
            break;
        }
        case QUADRANT.FOUR: {
            if (pointType === POINT_TYPE.RIGHT_DOWN) {
                // 矩形右下顶点
                startOffset.x = 0;
                startOffset.y = interval;

                endOffset.x = offset.x;
                endOffset.y = -offset.y;
            } else {
                // 矩形左下顶点
                startOffset.x = offset.x;
                startOffset.y = -offset.y;

                endOffset.x = 0;
                endOffset.y = interval;
            }
            break;
        }
    }

    return { startOffset, endOffset };
};

/**
 * @desc 通过弧线所在的象限 获得起点/终点 在x轴y轴上相对于顶点的偏移值
 * @param {string} arcQuadrant 弧线所处象限
 * @param {number} maxRadiusX 当前顶点X轴能够设置的最大弧度
 * @param {number} maxRadiusY 当前顶点Y轴能够设置的最大弧度
 * @param {number} radius 当前弧度
 * @returns {x,y}
 */
const _getOffsetOfArcQuadrant = (arcQuadrant, maxRadiusX, radius, maxRadiusY) => {
    let offset = {
        x: maxRadiusX > radius ? radius : maxRadiusX,
        y: maxRadiusY > radius ? radius : maxRadiusY,
    };
    switch (arcQuadrant) {
        case QUADRANT.ONE: {
            offset.x = -offset.x;
            break;
        }
        case QUADRANT.TWO: {
            break;
        }
        case QUADRANT.THREE: {
            offset.y = -offset.y;
            break;
        }
        case QUADRANT.FOUR: {
            offset.y = -offset.y;
            offset.x = -offset.x;
            break;
        }
    }

    return offset;
};

/**
 * @desc 通过顶点在矩形中所处位置以及起点/终点在在x、y轴上的偏移量 获得起点 和 终点 在x轴y轴上相对于顶点的偏移值
 * @param {{x,y}} offset 顶点的弧线开始点/结束点相对于顶点在x,y轴上的偏移
 * @param {POINT_TYPE} pointType 顶点在矩形中的位置
 * @returns {startOffset:{x,y}, endOffset:{x,y}}
 */
const _getStartAndEndOffset = (pointType, offset) => {
    let startOffset = { x: 0, y: 0 },
        endOffset = { x: 0, y: 0 };
    switch (pointType) {
        case POINT_TYPE.LEFT_DOWN:
        case POINT_TYPE.RIGHT_UP: {
            startOffset.x = offset.x;
            endOffset.y = offset.y;
            break;
        }
        case POINT_TYPE.LEFT_UP:
        case POINT_TYPE.RIGHT_DOWN: {
            startOffset.y = offset.y;
            endOffset.x = offset.x;
            break;
        }
    }
    return { startOffset, endOffset };
};

/**
 * @desc 通过每个拐点的起点,终点,控制点获取svg的path
 * @param {[{startPoint:{x,y},startControl:{x,y},{endPoint:{x,y},endControl:{x,y}}]} peakPointInfoList
 * @returns {string}
 */
const _getSvgPath = peakPointInfoList => {
    let path = '';

    peakPointInfoList.forEach((item, index) => {
        if (index === 0) {
            path += `M${item.startPoint.x}, ${item.startPoint.y}`;
        } else {
            path += `L${item.startPoint.x}, ${item.startPoint.y}`;
        }

        if (item.startControl !== null) {
            path += `C${item.startControl.x},${item.startControl.y} 
                ${item.endControl.x}, ${item.endControl.y}
                ${item.endPoint.x}, ${item.endPoint.y}
            `;
        }

        if (peakPointInfoList.length - 1 === index) {
            path += `L${peakPointInfoList[0].startPoint.x}, ${peakPointInfoList[0].startPoint.y}`;
        }
    });

    return path;
};

/**
 * @desc 获取文本框dom整体矩形的四个顶点
 * @param {[]} rectPeakPoints dom的每个子元素的顶点位置
 */
const _getEntiretyRect = rectPeakPoints => {
    if (rectPeakPoints.length <= 1) return rectPeakPoints;

    let leftUp = { x: 0, y: 0 },
        rightUp = { x: 0, y: 0 },
        rightDown = { x: 0, y: 0 },
        leftDown = { x: 0, y: 0 };

    let maxWidthIndex = 0;
    rectPeakPoints.forEach((item, index) => {
        let maxWidth = Math.abs(rectPeakPoints[maxWidthIndex][1].x - rectPeakPoints[maxWidthIndex][0].x);
        let width = Math.abs(item[1].x - item[0].x);

        if (width > maxWidth) maxWidthIndex = index;
    });

    const maxRect = rectPeakPoints[maxWidthIndex];
    leftUp.x = maxRect[0].x;
    leftUp.y = rectPeakPoints[0][0].y;

    rightUp.x = maxRect[1].x;
    rightUp.y = rectPeakPoints[0][1].y;

    rightDown.x = maxRect[1].x;
    rightDown.y = rectPeakPoints[rectPeakPoints.length - 1][2].y;

    leftDown.x = maxRect[0].x;
    leftDown.y = rectPeakPoints[rectPeakPoints.length - 1][3].y;

    // 整体的顶点只会存在一个矩形的四个顶点，但为了统一处理，依旧使用数组存储 当成只有一个子元素处理
    return [[leftUp, rightUp, rightDown, leftDown]];
};

/**
 * @desc 整理元素顶点坐标， 在上下俩个矩形的顶点十分相近的情况下将小的矩形扩大到大的矩形大小
 * @param {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints 矩形的顶点坐标集合
 * @param {number} minWidth 上下矩形相距的最小宽度
 */
const _trimElementPeakPointOfWidth = (rectPeakPoints, minWidth) => {
    for (let i = 0; i < rectPeakPoints.length - 1; i++) {
        const currentWidth = rectPeakPoints[i][1].x - rectPeakPoints[i][0].x;
        const nextWidth = rectPeakPoints[i + 1][1].x - rectPeakPoints[i + 1][0].x;

        let gap = currentWidth - nextWidth;

        // 判断当前矩形和下方矩形的宽度是否接近
        // 小于限定值时将小的矩形扩大成大矩形
        if (Math.abs(gap) > minWidth) {
            continue;
        }

        // 同步将小的矩形同步成大矩形同宽
        const __unifyRectWidth = (minRect, rect) => {
            minRect[0].x = rect[0].x;
            minRect[1].x = rect[1].x;
            minRect[2].x = rect[2].x;
            minRect[3].x = rect[3].x;
        };

        if (currentWidth > nextWidth) {
            __unifyRectWidth(rectPeakPoints[i + 1], rectPeakPoints[i]);
        } else {
            __unifyRectWidth(rectPeakPoints[i], rectPeakPoints[i + 1]);
        }
    }
};

/**
 * @desc 设置背景padding值
 * @param {*} rectPeakPoints
 * @param {*} padding
 * @returns
 */
const _trimElementPeakPointOfPadding = (rectPeakPoints, padding) => {
    if (!padding) return;
    let maxLength = rectPeakPoints.length - 1;
    rectPeakPoints.forEach((item, index) => {
        if (index === 0) {
            item[POINT_TYPE.LEFT_UP].y -= padding.top;
            item[POINT_TYPE.RIGHT_UP].y -= padding.top;
        }
        if (index === maxLength) {
            item[POINT_TYPE.LEFT_DOWN].y += padding.bottom;
            item[POINT_TYPE.RIGHT_DOWN].y += padding.bottom;
        }
        // 添加左右padding
        item[POINT_TYPE.LEFT_UP].x -= padding.left;
        item[POINT_TYPE.RIGHT_UP].x += padding.right;
        item[POINT_TYPE.LEFT_DOWN].x -= padding.left;
        item[POINT_TYPE.RIGHT_DOWN].x += padding.right;
    });
};

/**
 * @desc 通过最大圆角列表以及所指定的圆角比例，获得实际设置的的圆角列表
 * @param {} maxRadiusList
 * @param {*} radius
 */
const _getRadiusList = (maxRadiusList, radius) => {
    return maxRadiusList.map(item => item * radius);
};

/**
 * @desc 绘制svg
 * @param {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints
 * @param {number} radius
 * @param {boolean} hasFollowChildren 是否跟随子元素大小
 * @returns
 */
export const drawSvg = (
    rectPeakPoints,
    radius = 0,
    hasFollowChildren = false,
    padding = { left: 0, right: 0, top: 0, bottom: 0 },
    minWidthGap = 0,
) => {
    if (!rectPeakPoints) return;

    // 如果背景样式不跟随文字则取宽度最大的矩形为整个文字dom的宽
    // 获取整体的一个大矩形四个点返回
    if (!hasFollowChildren) {
        rectPeakPoints = _getEntiretyRect(rectPeakPoints);
    } else {
        // 跟随内容设置背景时整理顶点坐标，防止上下宽度差距过小导致圆角样式不好看
        // 待优化
        _trimElementPeakPointOfWidth(rectPeakPoints, minWidthGap);
    }

    _trimElementPeakPointOfPadding(rectPeakPoints, padding);

    let { svgPeakPoints, maxRadiusList } = _getBackgroundSvgPeakPoint(rectPeakPoints);

    // 获取每个拐点的圆角弧度
    let pointRadiusList = _getRadiusList(maxRadiusList, radius);
    let peakPointInfoList = _getArcStartAndEndPoints(svgPeakPoints, pointRadiusList);

    let path = _getSvgPath(peakPointInfoList);

    let svgBackground;
    svgBackground = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgBackground.setAttribute('style', 'width:100%;height:100%;overflow: inherit');

    let pathDom = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pathDom.setAttribute('d', path);
    pathDom.setAttribute('shape-rendering', 'geometricPrecision');
    svgBackground.appendChild(pathDom);

    return svgBackground;
};
